/**
 * Cards Slider Web Component
 * Initializes Swiper slider for mobile cards carousel
 */
class CardsSlider extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
  }

  connectedCallback() {
    this.initSwiper();
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  initSwiper() {
    if (this.swiper) return;
    if (!window.Swiper) {
      document.addEventListener('mma:swiper-ready', () => this.initSwiper(), { once: true });
      return;
    }

    const swiperEl = this.querySelector('.cards-swiper');
    if (!swiperEl) return;

    const paginationEl = this.querySelector('.cards-swiper-pagination');

    this.swiper = new Swiper(swiperEl, {
      slidesPerView: 2.2,
      spaceBetween: 8,
      pagination: {
        el: paginationEl,
        type: 'bullets',
        clickable: true,
      },      
    });
  }
}

customElements.define('cards-slider', CardsSlider);

